<div class="form-inline" [formGroup]="preferenceGroup" style="position: relative;">
  <div class="row">
    <div class="col-md-3 col-md-offset-3">
      <div class="form-group">
        <select class="form-control" formControlName="conjunction" *ngIf="index != 0 && !shouldHideConjunction">
          <option [ngValue]="conjunctionEnum.And">{{ conjunctionEnum[conjunctionEnum.And] }}</option>
          <option [ngValue]="conjunctionEnum.Or">{{ conjunctionEnum[conjunctionEnum.Or] }}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-10" style="position: relative;">
      <div class="group-label" *ngIf="groupLabel">
        <strong>{{ groupLabel }}</strong>
      </div>

      <div class="preference-group-row preference-item-list-border"
           [ngClass]="{ 'preference-item-list-focused': focused }"
           [class.has-error]="preferenceGroup.invalid"
           (click)="focus()"
           style="position: relative;">

        <app-pollination-preference-item-list [preferenceGroup]="preferenceGroup"></app-pollination-preference-item-list>

        <div class="item-delete-container" *ngIf="hasItems">
          <i class="fa fa-trash fa-sm"
             (click)="deleteLastItem(); $event.stopPropagation()"
             title="Delete last item (Backspace)"
             aria-hidden="true"></i>
        </div>
      </div>
    </div>

    <div class="col-sm-1 preference-group-row" *ngIf="canDelete">
      <i class="fa fa-trash-o fa-lg" (click)="delete()"></i>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/pollination-instructions/pollination-preference-group/pollination-preference-group.component.html